import axiosClient from "api/apiClient";

interface IOptions {
  id?: number;
  sort?: string;
  search?: string;
    status?: boolean;
}

export const APIGetClassroom = (options: IOptions) => {
  let sort = "";
  let search = "";
  if (options.hasOwnProperty("sort")) {
    sort = "sort=" + options.sort;
  }
  if (options.hasOwnProperty("search")) {
    search = "&filter[search]=" + options.sort;
  }
  return axiosClient.get(`/classrooms/${options.id}?${search}${sort}`);
};

export const APIUpdateClassroom = (id: string, data: object) => {
  return axiosClient.put(`/classrooms/${id}`, data);
};

export const APIRestoreClassroom = (options: IOptions) => {
    let status = "";

    if (options.hasOwnProperty("status")) {
        status = "?status=" + options.status;
    }

  return axiosClient.get(`/classrooms/restore/${options.id}${status}`);
};

export const APIPostClassroom = (data: object) => {
  return axiosClient.post(`/classrooms`, data);
};


export const APIArchiveClassroom = (options : IOptions) => {
    let status = "";

    if (options.hasOwnProperty("status")) {
        status = "?status=" + options.status;
    }

    return axiosClient.get(`classrooms/archive/${options.id}${status}`);
};